<template>
  <section :id="id" class="project" :style="{ '--accent': accent }">
    <header class="project-head container">
      <div v-reveal class="emblem">
        <div class="emblem-glow"></div>
        <slot name="emblem">
          <div class="app-icon">
            <font-awesome-icon :icon="icon" />
          </div>
        </slot>
      </div>
      <h2 v-reveal="80" class="project-title gradient-text">{{ title }}</h2>
      <p v-reveal="160" class="project-tagline">{{ tagline }}</p>
      <div v-reveal="240" class="chip project-chip">
        <span class="dot"></span>
        {{ chip }}
      </div>
    </header>

    <div class="container">
      <div class="bento">
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProjectSection',
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    tagline: { type: String, required: true },
    chip: { type: String, required: true },
    accent: { type: String, required: true },
    icon: { type: Array, default: () => ['fas', 'star'] },
  },
};
</script>

<style scoped>
.project {
  position: relative;
  z-index: 1;
  padding: 160px 0 40px;
}

.project-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 72px;
}

.emblem {
  position: relative;
  margin-bottom: 44px;
}

.emblem-glow {
  position: absolute;
  inset: -70px;
  border-radius: 50%;
  background: radial-gradient(circle, color-mix(in srgb, var(--accent) 38%, transparent), transparent 65%);
  filter: blur(10px);
  z-index: -1;
}

.app-icon {
  display: grid;
  place-items: center;
  width: 132px;
  height: 132px;
  border-radius: 34px;
  background:
    linear-gradient(160deg, rgba(255, 255, 255, 0.35), transparent 45%),
    linear-gradient(160deg, color-mix(in srgb, var(--accent) 85%, #fff), color-mix(in srgb, var(--accent) 60%, #000));
  box-shadow:
    inset 0 2px 1px rgba(255, 255, 255, 0.45),
    inset 0 -6px 18px rgba(0, 0, 0, 0.3),
    0 24px 60px rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 56px;
  filter: drop-shadow(0 0 30px color-mix(in srgb, var(--accent) 40%, transparent));
}

.project-title {
  font-size: clamp(56px, 9vw, 112px);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.04em;
  padding-bottom: 6px;
}

.project-tagline {
  margin-top: 18px;
  font-size: clamp(17px, 1.6vw, 20px);
  color: var(--text-dim);
  max-width: 560px;
}

.project-chip {
  margin-top: 28px;
  font-family: 'JetBrains Mono', ui-monospace, monospace;
  font-size: 13px;
  font-weight: 400;
}

.project-chip:hover {
  transform: none;
}
</style>
